import { Injectable } from '@angular/core';
import { AccessoryCharge, ShipmentInfo } from '@cargos/sprintpay-models';
import { Observable, map } from 'rxjs';
import { AwbLookUpService } from 'src/app/shared/services';
import { AccessoriesService } from 'src/app/shared/services/accessories/accessories.service';

@Injectable()
export class AccessoriesAllianceImplementationService extends AccessoriesService {
    constructor(private awbLookUpService: AwbLookUpService) {
        super();
    }

    fetchAccessories(): Observable<AccessoryCharge[]> {
        return this.awbLookUpService.getCurrentPayment$().pipe(
            map((shipmentInfo: ShipmentInfo | null) => {
                return shipmentInfo?.accessorialChargeRates || [];
            }),
            map((accessories: AccessoryCharge[]) => this.filterAccessoriesWithOutRate(accessories)),
            map((accessories: AccessoryCharge[]) => this.sortAccessoriesByType(accessories))
        );
    }
}
